import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { deleteAttachment } from '../../../api/objective/attachments.api';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

const DeleteAttachment = ({
  name,
  objectiveAttachmentId,
  objectiveId,
  ownerId,
  ownerType,
  onSuccess
}) => {
  const { t } = useTranslation();

  const [ open, setOpen ] = useState(false);

  const mutation = useMutation(
    async () => {
      return await deleteAttachment({
        objectiveAttachmentId,
        objectiveId,
        ownerId,
        ownerType
      });
    },
    {
      onSuccess: () => {
        onSuccess?.();
      },
      onSettled: () => {
        setOpen(false);
      }
    }
  );

  return (
    <>
      <a
        onClick={ () => setOpen(true) }
        style={ {
          display: 'block',
          cursor: 'pointer',
          fontSize: 12,
          margin: '8px 0'
        } }
      >
        {t('objective.comment.delete')}
      </a>
      <Dialog open={ open } onClose={ () => setOpen(false) }>
        <DialogTitle>
          {t('objective.attachment.title.delete')}
        </DialogTitle>
        <DialogContent>
          {t('objective.attachment.deleteConfirm')}
          <div style={ { marginTop: 8, wordBreak: 'break-word' } }>{name}</div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={ mutation.mutate }
            variant='contained'
            color='primary'
          >
            {t('objective.comment.delete')}
          </Button>
          <Button
            onClick={ () => setOpen(false) }
            color='primary'
          >
            { t('objective.dialog.cancel') }
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={ mutation.isError }>
        <DialogContent>
          {mutation.error?.message}
        </DialogContent>
        <DialogActions>
          <Button onClick={ mutation.reset }>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteAttachment;